import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const clearFilters = createAction(`${storeName}/clearFilters`);
